import React from 'react';

import { isTouchScreen } from '../../lib/isTouchScreen';
import { TooltipStateful } from '../../Tooltip';
import type { ButtonProps } from '../Button.types';

export type ButtonWrapperProps = Pick<
    ButtonProps,
    'tooltipContent' | 'hasTooltip' | 'tooltipProps'
> & {
    children: React.ReactElement;
    isIconButton?: boolean;
};

export const ButtonWrapper: React.FC<ButtonWrapperProps> = (props) => {
    const { children, tooltipContent, hasTooltip, isIconButton, tooltipProps } = props;

    const showDefaultIconTooltip = isIconButton && typeof hasTooltip === 'undefined';
    const showTooltip = !isTouchScreen() && (hasTooltip || showDefaultIconTooltip);

    if (tooltipContent && showTooltip) {
        return (
            <TooltipStateful {...tooltipProps} content={tooltipContent}>
                {children}
            </TooltipStateful>
        );
    }

    return children;
};
